import React from 'react';
import { Box,Stack,Typography, Button } from '@mui/material';

import HeroBannerImage from "../assets/images/banner.jpg";

const HeroBanner = () => {
  return (
    <Box sx={{mt:{lg:"100px", xs:'40px'},
                ml:{sm:'50px'}}} position="relative" p='20px'>
        <Typography color="#FF2625" fontWeight="600" fontSize="26px">
            Sale de gym
        </Typography>
         <Typography fontWeight={700}
            sx={{fontSize:{lg:'44px', xs:'40px'}}} mb="10px" mt="10px">
            Suez, souriez <br/> et répétez
         </Typography>
         <Typography fontSize={"22px"} lineHeight="35px" mb={4} >
            Découvrez les exercices les plus efficaces
         </Typography>
         <Button href="#exercices" variant="contained" color="error"
            sx={{backgroundColor:"#FF2625", padding:'10px'}} >Explorer les exercices</Button>
        <Typography fontWeight={600}
                    color="#FF2625"
                    sx={{opacity: 0.1, display:{lg:'block', xs:'none'}}} 
                    fontSize="200px">
            Exercice
        </Typography>
        <img src={HeroBannerImage} alt="Banniere" className='hero-banner-img ' />
    </Box>
  )
}

export default HeroBanner